import type { ResolveSelectFieldsOptions } from '@cli-types/next-adapter/generators.js'
import { renderSelectFieldsResolverRenderer } from '@next-adapter/templates/renderers/generators/actions/select-fields-resolver.js'

export function generateResolveSelectFieldsSource({
  Singular,
  selectFields,
  selectOptionsTableVar,
  hasCreatableSelectFields,
  exported
}: ResolveSelectFieldsOptions): string {
  const staticLabelMaps = selectFields
    .map((readField) => {
      const key = readField.path.join('.')
      const entries = (readField.field.options ?? [])
        .map((option) => `${JSON.stringify(option.value)}: ${JSON.stringify(option.label)}`)
        .join(', ')
      return `  ${JSON.stringify(key)}: { ${entries} }`
    })
    .join(',\n')
  const dynamicRowsBlock = hasCreatableSelectFields
    ? renderSelectFieldsResolverRenderer({
        kind: 'renderResolveSelectFieldsSourceDynamicRowsTemplate',
        props: {
          selectOptionsTableVar: selectOptionsTableVar
        }
      })
    : ''
  const assignments = selectFields
    .map((readField) => {
      const key = readField.path.join('.')
      return `    resolveSelectFieldPath(source, ${JSON.stringify(readField.path)}, labelMaps[${JSON.stringify(key)}] ?? {})`
    })
    .join('\n')

  return renderSelectFieldsResolverRenderer({
    kind: 'renderResolveSelectFieldsSourceStaticSelectOptionLabelsTemplate',
    props: {
      staticLabelMaps: staticLabelMaps,
      exportedExport: exported ? 'export ' : '',
      singular: Singular,
      dynamicRowsBlock: dynamicRowsBlock,
      assignments: assignments
    }
  })
}
